import { Link } from "react-router-dom";

export default function TermsCheckbox({ checked, onChange, testId = "terms-accept" }) {
  return (
    <label className="flex items-start gap-2 text-white/60 text-xs cursor-pointer select-none mt-2" data-testid={testId}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-[#C5A059] cursor-pointer"
        data-testid={`${testId}-input`}
        required
      />
      <span>
        I have read and accept the{" "}
        <Link to="/legal/terms" target="_blank" className="text-[#C5A059] underline hover:text-[#E6C785]">
          Terms of Service
        </Link>{" "}
        and the{" "}
        <Link to="/legal/cancellation" target="_blank" className="text-[#C5A059] underline hover:text-[#E6C785]">
          Cancellation Policy
        </Link>
        .<span className="text-red-400 ml-1">*</span>
      </span>
    </label>
  );
}
